import { TransactionType, } from './TransactionStepDialog.types';
export const isMessageSignatureRequest = (request) => request.type === TransactionType.signMessage;
export const isTypedDataRequest = (request) => request.type === TransactionType.signTypedData;
export const isTransactionRequest = (request) => request.type === TransactionType.signTransaction;
export const isSignTransactionDataRequest = (request) => request.type === TransactionType.signTransactionData;
